"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconVanFilled = function IconVanFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.2 26.66L40.64 22.19C40.3098 21.9128 40.0379 21.5729 39.84 21.19L36.58 15.32C36.2126 14.6304 35.6675 14.0516 35.0011 13.6437C34.3347 13.2357 33.5712 13.0135 32.79 13H6.33001C5.91407 13.0181 5.51607 13.1745 5.19907 13.4444C4.88208 13.7143 4.66421 14.0823 4.58001 14.49L3.34001 20.33C3.11218 21.405 2.99822 22.5011 3.00001 23.6V32.9C2.99466 33.4499 3.20734 33.9796 3.59151 34.3732C3.97569 34.7667 4.50009 34.9921 5.05001 35H7.00001C7.00001 36.1935 7.47411 37.3381 8.31803 38.182C9.16194 39.0259 10.3065 39.5 11.5 39.5C12.6935 39.5 13.8381 39.0259 14.682 38.182C15.5259 37.3381 16 36.1935 16 35H32C32 36.1935 32.4741 37.3381 33.318 38.182C34.1619 39.0259 35.3065 39.5 36.5 39.5C37.6935 39.5 38.8381 39.0259 39.682 38.182C40.5259 37.3381 41 36.1935 41 35H45C45.5412 34.9792 46.0528 34.7482 46.4263 34.356C46.7998 33.9639 47.0056 33.4415 47 32.9V28.4C47.0043 28.0688 46.9347 27.7407 46.7963 27.4397C46.6579 27.1388 46.4542 26.8724 46.2 26.66V26.66ZM11.5 36.75C10.9908 36.7492 10.497 36.5756 10.0992 36.2577C9.70137 35.9399 9.42316 35.4965 9.31001 35C9.26973 34.8364 9.24958 34.6685 9.25001 34.5C9.25001 33.9033 9.48706 33.331 9.90902 32.909C10.331 32.4871 10.9033 32.25 11.5 32.25C12.0967 32.25 12.669 32.4871 13.091 32.909C13.513 33.331 13.75 33.9033 13.75 34.5C13.7504 34.6685 13.7303 34.8364 13.69 35C13.5769 35.4965 13.2986 35.9399 12.9008 36.2577C12.5031 36.5756 12.0092 36.7492 11.5 36.75V36.75ZM36.5 36.75C35.9908 36.7492 35.497 36.5756 35.0992 36.2577C34.7014 35.9399 34.4232 35.4965 34.31 35C34.2697 34.8364 34.2496 34.6685 34.25 34.5C34.25 33.9033 34.4871 33.331 34.909 32.909C35.331 32.4871 35.9033 32.25 36.5 32.25C37.0967 32.25 37.669 32.4871 38.091 32.909C38.513 33.331 38.75 33.9033 38.75 34.5C38.7504 34.6685 38.7303 34.8364 38.69 35C38.5769 35.4965 38.2986 35.9399 37.9009 36.2577C37.5031 36.5756 37.0092 36.7492 36.5 36.75V36.75Z",
    fill: color
  }));
};

IconVanFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconVanFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconVanFilled;
exports.default = _default;